@if (!messages() || loadingPrev()) {
  <app-loading />
}
@if (messages() && !loadingPrev()) {
  <a class="load-more fake-link" (click)="loadPrev()">load prev</a>
}
<cdk-virtual-scroll-viewport #viewport class="messages"
                             [class.scroll-lock]="scrollLock()"
                             [itemSize]="itemSize"
                             [style.height.px]="containerHeight()"
                             (scrolledIndexChange)="onScroll($event)">
  <app-chat-entry *cdkVirtualFor="let ref of messages(); let index = index; let odd = odd"
                  [ref]="ref"
                  [class.odd]="odd"
                  (click)="scrollLock.set(index)"
                  [focused]="scrollLock() === index" />
</cdk-virtual-scroll-viewport>
@if (notAtBottom()) {
  <div class="scroll-to-bottom" tabindex="0" (click)="scrollToBottom()" i18n>More messages below</div>
}
<div class="spacer"></div>
<div class="input-box"
     [class.dropping]="dropping()"
     (dragenter)="dropping.set(true)"
     (dragleave)="dragLeave($event)"
     (dragover)="$event.preventDefault()"
     (drop)="handleDrop($event)">
  @if (!config.websockets) {
    <button type="button"
            class="refresh"
            [title]="'last polled ' + (lastPoll() | relative)"
            (click)="refresh()" i18n>🔄</button>
  }
  @for (button of editorPushButtons(); track button; let i = $index) {
    @if (!button.event) {
      <button type="button"
              (click)="toggleTag(button)"
              [title]="button.title" i18n>{{(buttonOn(button.toggle!) ? button.labelOn : button.labelOff) || button.label }}</button>
    }
  }
  <input type="text"
         i18n-placeholder
         placeholder="chat..."
         enterkeyhint="send"
         size="10"
         [value]="addText()"
         (input)="addText.set($any($event.target).value)"
         (keydown)="$event.key === 'Enter' && add() || true"
         (paste)="handlePaste($event)"
         appAutofocus>
  <button type="button"
          class="add"
          i18n-title
          title="Send"
          (click)="add()" i18n>⏎</button>
</div>
@if (uploads().length) {
  <div class="upload-progress">
    <div class="upload-list">
      @for (upload of uploads(); track upload.id) {
        <div class="upload-item">
          <div class="upload-filename">{{ upload.name }}</div>
          <div class="upload-controls">
            @if (upload.error) {
              <span class="upload-error">{{ upload.error }}</span>
            } @else if (upload.completed) {
              <span class="upload-complete" i18n>✅ Complete</span>
            } @else {
              <progress class="upload-progress-bar" max="100" [value]="upload.progress"></progress>
              <span class="upload-percentage">{{ upload.progress }}%</span>
            }
            @if (!upload.completed && !upload.error) {
              <button type="button"
                      class="upload-cancel"
                      (click)="cancelUpload(upload)"
                      i18n-title title="Cancel upload" i18n>&ndash;</button>
            }
          </div>
        </div>
      }
    </div>
    @if (uploads().length > 1) {
      <div class="upload-actions">
        <button type="button"
                class="upload-cancel-all"
                (click)="cancelAllUploads()"
                i18n>&ndash; remove all</button>
      </div>
    }
  </div>
  @if (hasActiveUploads()) {
    <app-loading class="upload-loading" [batch]="true" />
  }
}
<span class="hints">
  @if (admin.getPlugin('plugin/latex')) {
    <input id="latex" type="checkbox" [checked]="latex()" (input)="latex.set(!latex())">
    <label for="latex" i18n>
      LaTeX plugin
      <sup><a target="_blank" href="https://katex.org/docs/supported.html">help</a></sup>
    </label>
  }
</span>
<div class="list-container">
  @for (ref of errored(); track ref.origin + ref.url) {
    <button type="button" class="retry" (click)="retry(ref)" i18n>retry</button>
    <app-chat-entry [ref]="ref" [loading]="false" />
  }
  @for (ref of sending(); track ref.url) {
    <app-chat-entry [ref]="ref" />
  }
</div>
